function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".a{fill:#00e794;}.b{fill:#fff;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-78.66 -57.893)"
}, React.createElement("path", {
  className: "a",
  d: "M88.613,67.846H78.66V92.73h9.953V67.846Z"
}), React.createElement("path", {
  className: "a",
  d: "M108.52,92.73H88.613v9.953H108.52V122.59h9.953V67.846H108.52Z"
}), React.createElement("path", {
  className: "a",
  d: "M168.24,67.846,153.31,92.73,138.38,67.846h-9.953V122.59h9.953V87.753l9.953,14.93h9.953l9.953-14.93v14.93h9.953V67.846Z"
}), React.createElement("rect", {
  className: "a",
  width: 9.953,
  height: 19.907,
  transform: "translate(178.194 102.683)"
}), React.createElement("path", {
  className: "a",
  d: "M78.66,117.613v4.977h9.953V102.683H78.66Z"
}), React.createElement("path", {
  className: "a",
  d: "M227.961,122.59,215.309,101.1a17.419,17.419,0,0,0-7.255-33.254H188.147V92.73H198.1V77.8h9.953a7.465,7.465,0,0,1,0,14.93H198.1v9.953h7.557l11.719,19.907Z"
}), React.createElement("rect", {
  className: "a",
  width: 9.953,
  height: 9.953,
  transform: "translate(297.635 67.846)"
}), React.createElement("rect", {
  className: "a",
  width: 9.953,
  height: 9.953,
  transform: "translate(307.588 57.893)"
}), React.createElement("path", {
  className: "a",
  d: "M317.541,67.846V77.8h-9.953v9.953h0a19.907,19.907,0,0,0,19.907-19.906h-9.954Z"
}), React.createElement("path", {
  className: "b",
  d: "M246.29,119.148a2.257,2.257,0,0,0,2.484,1.656,2.324,2.324,0,0,0,1.973-.881l1.832,1.057a4.368,4.368,0,0,1-3.841,1.885,4.735,4.735,0,0,1-3.505-1.321,4.648,4.648,0,0,1,3.329-7.981,4.2,4.2,0,0,1,3.2,1.339,4.648,4.648,0,0,1,1.26,3.312,5.392,5.392,0,0,1-.088.934Zm-.036-1.762h4.493a2.134,2.134,0,0,0-.8-1.339,2.3,2.3,0,0,0-1.384-.441,2.391,2.391,0,0,0-1.515.467A2.235,2.235,0,0,0,246.254,117.386Z"
}), React.createElement("path", {
  className: "b",
  d: "M256.757,116.311q0,.353.467.573a6.169,6.169,0,0,0,1.136.387,11.958,11.958,0,0,1,1.339.423,2.608,2.608,0,0,1,1.137.855,2.362,2.362,0,0,1,.467,1.5,2.418,2.418,0,0,1-1.014,2.088,4.21,4.21,0,0,1-2.528.731,3.705,3.705,0,0,1-3.7-2.1l1.974-1.11a1.632,1.632,0,0,0,1.726,1.145q1.215,0,1.216-.758,0-.351-.467-.572a6.672,6.672,0,0,0-1.137-.4,11.808,11.808,0,0,1-1.338-.44,2.75,2.75,0,0,1-1.137-.837,2.2,2.2,0,0,1-.467-1.436,2.458,2.458,0,0,1,.961-2.052,3.761,3.761,0,0,1,2.387-.749,3.994,3.994,0,0,1,1.956.484,3.543,3.543,0,0,1,1.391,1.383l-1.938,1.057a1.448,1.448,0,0,0-1.409-.9,1.3,1.3,0,0,0-.731.193A.606.606,0,0,0,256.757,116.311Z"
}), React.createElement("path", {
  className: "b",
  d: "M294.474,122.865a4.651,4.651,0,1,1,0-9.3,4.576,4.576,0,0,1,2.343.616,4.1,4.1,0,0,1,1.6,1.657l-1.955,1.145a2,2,0,0,0-.8-.864,2.332,2.332,0,0,0-1.207-.317,2.273,2.273,0,0,0-1.691.679,2.559,2.559,0,0,0,0,3.453,2.276,2.276,0,0,0,1.691.678,2.419,2.419,0,0,0,1.224-.308,1.936,1.936,0,0,0,.8-.855l1.974,1.128a4.415,4.415,0,0,1-1.639,1.665A4.525,4.525,0,0,1,294.474,122.865Z"
}), React.createElement("path", {
  className: "b",
  d: "M242.191,113.9h-.038a3.608,3.608,0,0,0-1.087.164,2.073,2.073,0,0,0-.889.576v-.833h-2.263v8.78h2.263v-4.677a2.18,2.18,0,0,1,.422-1.446,1.322,1.322,0,0,1,.613-.412c.023-.008.043-.015.071-.023a3.148,3.148,0,0,1,.855-.1c.061,0,.123,0,.189,0l.105,0c.137.009.271.021.4.042v-2.025A3.866,3.866,0,0,0,242.191,113.9Z"
}), React.createElement("path", {
  className: "b",
  d: "M264.918,119.148A2.257,2.257,0,0,0,267.4,120.8a2.325,2.325,0,0,0,1.973-.881l1.833,1.057a4.371,4.371,0,0,1-3.841,1.885,4.736,4.736,0,0,1-3.506-1.321,4.648,4.648,0,0,1,3.329-7.981,4.2,4.2,0,0,1,3.2,1.339,4.648,4.648,0,0,1,1.26,3.312,5.3,5.3,0,0,1-.088.934Zm-.035-1.762h4.492a2.13,2.13,0,0,0-.8-1.339,2.3,2.3,0,0,0-1.384-.441,2.4,2.4,0,0,0-1.515.467A2.229,2.229,0,0,0,264.883,117.386Z"
}), React.createElement("path", {
  className: "b",
  d: "M279.982,113.808h2.262v8.77h-2.262v-1.035a3.444,3.444,0,0,1-2.859,1.28,3.974,3.974,0,0,1-3.008-1.341,4.94,4.94,0,0,1,0-6.578,3.974,3.974,0,0,1,3.008-1.341,3.444,3.444,0,0,1,2.859,1.28Zm-4.175,6.165a2.337,2.337,0,0,0,1.737.693,2.366,2.366,0,0,0,1.745-.693,2.633,2.633,0,0,0,0-3.56,2.366,2.366,0,0,0-1.745-.693,2.337,2.337,0,0,0-1.737.693,2.658,2.658,0,0,0,0,3.56Z"
}), React.createElement("rect", {
  className: "b",
  width: 2.263,
  height: 6.517,
  transform: "translate(305.412 116.071)"
}), React.createElement("path", {
  className: "b",
  d: "M302.413,113.808v-3.515H300.15v12.3h2.262v-6.517h3v-2.263Z"
}), React.createElement("path", {
  className: "b",
  d: "M288.557,113.9h-.038a3.608,3.608,0,0,0-1.087.164,2.073,2.073,0,0,0-.889.576v-.833H284.28v8.78h2.263v-4.677a2.186,2.186,0,0,1,.421-1.446,1.338,1.338,0,0,1,.445-.345,1.369,1.369,0,0,1,.168-.067l.072-.023a3.143,3.143,0,0,1,.855-.1c.061,0,.123,0,.189,0l.105,0c.136.009.271.021.4.042v-2.025A3.866,3.866,0,0,0,288.557,113.9Z"
}), React.createElement("path", {
  className: "b",
  d: "M259.227,100.042h2.263v8.77h-2.263v-1.035a3.444,3.444,0,0,1-2.859,1.28,3.973,3.973,0,0,1-3.008-1.342,4.939,4.939,0,0,1,0-6.577,3.973,3.973,0,0,1,3.008-1.342,3.442,3.442,0,0,1,2.859,1.281Zm-4.174,6.165a2.337,2.337,0,0,0,1.736.693,2.367,2.367,0,0,0,1.746-.693,2.637,2.637,0,0,0,0-3.561,2.37,2.37,0,0,0-1.746-.692,2.34,2.34,0,0,0-1.736.692,2.659,2.659,0,0,0,0,3.561Z"
}), React.createElement("path", {
  className: "b",
  d: "M277.444,108.812h-2.63l-3.192-3.985v3.985h-2.263v-11.5h2.263v6.6l3.016-3.874h2.7l-3.525,4.333Z"
}), React.createElement("path", {
  className: "b",
  d: "M280.026,105.356A2.245,2.245,0,0,0,282.5,107a2.314,2.314,0,0,0,1.965-.877l1.824,1.052a4.35,4.35,0,0,1-3.824,1.877,4.717,4.717,0,0,1-3.49-1.316,4.49,4.49,0,0,1-1.315-3.314,4.536,4.536,0,0,1,1.3-3.307,4.468,4.468,0,0,1,3.333-1.324,4.183,4.183,0,0,1,3.183,1.333,4.63,4.63,0,0,1,1.254,3.3,5.33,5.33,0,0,1-.087.929Zm-.036-1.754h4.473a2.126,2.126,0,0,0-.8-1.333,2.29,2.29,0,0,0-1.377-.438,2.382,2.382,0,0,0-1.509.465A2.225,2.225,0,0,0,279.99,103.6Z"
}), React.createElement("path", {
  className: "b",
  d: "M293.472,102.305H291.49v3.56a.866.866,0,0,0,.228.666,1.04,1.04,0,0,0,.667.237,9.562,9.562,0,0,0,1.087-.009v2.053a4.828,4.828,0,0,1-3.289-.439,2.92,2.92,0,0,1-.955-2.508v-3.56H287.7v-2.263h1.526V98.27l2.262-.683v2.455h1.982Z"
}), React.createElement("path", {
  className: "b",
  d: "M249.974,100.776a3.119,3.119,0,0,0-2.412-.982,2.978,2.978,0,0,0-2.577,1.213l-.018.026v-.991h-7.053v8.77h2.263v-6.507h3.069v6.507h2.263v-4.93a2.223,2.223,0,0,1,.43-1.474,1.487,1.487,0,0,1,1.2-.509,1.37,1.37,0,0,1,1.087.439,1.792,1.792,0,0,1,.386,1.228v5.246h2.264v-5.4A3.739,3.739,0,0,0,249.974,100.776Z"
}), React.createElement("path", {
  className: "b",
  d: "M267.454,100.136h-.037a3.61,3.61,0,0,0-1.088.164,2.08,2.08,0,0,0-.889.577v-.833h-2.262v8.769h2.262v-4.667a2.186,2.186,0,0,1,.422-1.446,1.334,1.334,0,0,1,.444-.344,1.565,1.565,0,0,1,.169-.068c.023-.007.043-.015.071-.023a3.16,3.16,0,0,1,.856-.1c.06,0,.123,0,.188,0,.036,0,.068,0,.105,0a3.921,3.921,0,0,1,.4.042v-2.026A4,4,0,0,0,267.454,100.136Z"
}), React.createElement("path", {
  className: "b",
  d: "M269.359,95.049v-12.3h2.263v12.3Z"
}), React.createElement("rect", {
  className: "b",
  width: 2.263,
  height: 6.507,
  transform: "translate(243.176 88.542)"
}), React.createElement("path", {
  className: "b",
  d: "M240.177,86.28V82.754h-2.262v12.3h2.262V88.542h3V86.28Z"
}), React.createElement("path", {
  className: "b",
  d: "M249.52,91.62A2.258,2.258,0,0,0,252,93.276a2.326,2.326,0,0,0,1.973-.881l1.832,1.057a4.371,4.371,0,0,1-3.841,1.885,4.736,4.736,0,0,1-3.506-1.322,4.649,4.649,0,0,1,3.33-7.981,4.2,4.2,0,0,1,3.2,1.339,4.65,4.65,0,0,1,1.26,3.313,5.4,5.4,0,0,1-.088.934Zm-.036-1.763h4.493a2.13,2.13,0,0,0-.8-1.338,2.3,2.3,0,0,0-1.383-.441,2.391,2.391,0,0,0-1.515.467A2.233,2.233,0,0,0,249.484,89.857Z"
}), React.createElement("path", {
  className: "b",
  d: "M264.956,86.28h2.262v8.769h-2.262V94.014a3.443,3.443,0,0,1-2.859,1.281,3.973,3.973,0,0,1-3.008-1.342,4.939,4.939,0,0,1,0-6.577,3.973,3.973,0,0,1,3.008-1.342,3.446,3.446,0,0,1,2.859,1.28Zm-4.175,6.165a2.339,2.339,0,0,0,1.737.693,2.365,2.365,0,0,0,1.745-.693,2.634,2.634,0,0,0,0-3.561,2.368,2.368,0,0,0-1.745-.692,2.342,2.342,0,0,0-1.737.692,2.659,2.659,0,0,0,0,3.561Z"
}), React.createElement("path", {
  className: "b",
  d: "M278.614,88.543h-1.982V92.1a.868.868,0,0,0,.228.667,1.044,1.044,0,0,0,.666.236A9.786,9.786,0,0,0,278.614,93V95.05a4.822,4.822,0,0,1-3.289-.439,2.917,2.917,0,0,1-.955-2.508v-3.56h-1.526V86.28h1.526V84.509l2.262-.684V86.28h1.982Z"
}), React.createElement("rect", {
  className: "b",
  width: 2.263,
  height: 6.507,
  transform: "translate(285.439 88.542)"
}), React.createElement("path", {
  className: "b",
  d: "M282.44,86.28V82.754h-2.262v12.3h2.262V88.542h3V86.28Z"
}));

var SvgLogosvg = function SvgLogosvg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 248.835,
    height: 64.972,
    viewBox: "0 0 248.835 64.972",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogosvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logosvg.f4b8b217.svg";
export { ForwardRef as ReactComponent };